// List-view spec line (snippets/card-spec-line.liquid): when a card swatch is pressed, show that variant's line.
document.addEventListener('card-variants:select', (event) => {
  const picker = event.detail;
  if (!(picker instanceof HTMLElement)) return;
  const card = picker.closest('.fz-lcard');
  const pressed = picker.querySelector('button[aria-pressed="true"][data-variant-id]');
  if (!card || !pressed) return;
  const lines = card.querySelectorAll('[data-spec-for]');
  for (const line of lines) line.hidden = line.dataset.specFor !== pressed.dataset.variantId;
});
